import React from 'react';
import PropTypes from 'prop-types';
import './Heading.scss';

const Heading = props => (
  <header className="heading">
    <strong className="heading__title">{props.title}</strong>
  </header>
);

Heading.propTypes = {
  /** title */
  title: PropTypes.string,
};

Heading.defaultProps = {
  title: null,
};

export default Heading;
